import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component EyeOffSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <EyeOffSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <EyeOffSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const EyeOffSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      viewBox="0 0 12 12"
      data-testid="EyeOffSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="m1.05 1.05 9.9 9.9-.707.707L8.205 9.62C7.517 9.866 6.775 10 6 10 3.273 10 .944 8.341 0 6a6.35 6.35 0 0 1 1.971-2.615L.343 1.757zM1.19 6C2.09 7.792 3.95 8.933 6 8.933q.696-.002 1.35-.168L6.176 7.59Q6.089 7.6 6 7.6c-.904 0-1.636-.716-1.636-1.6q0-.106.013-.207L2.736 4.15A5.3 5.3 0 0 0 1.189 6M6 2c2.727 0 5.056 1.659 6 4a6.35 6.35 0 0 1-1.972 2.615l-.765-.766A5.3 5.3 0 0 0 10.811 6C9.91 4.208 8.05 3.067 6 3.067c-.463 0-.916.058-1.35.168l-.857-.855A6.6 6.6 0 0 1 6 2m0 2.4c.904 0 1.636.716 1.636 1.6q0 .105-.013.208l-1.8-1.799Q5.91 4.4 6 4.4"
      />
    </svg>
  )
);
EyeOffSmallIcon.displayName = "EyeOffSmallIcon";
export default EyeOffSmallIcon;
